/* 请求接口地址管理 */
// export var IP =
//   process.env.NODE_ENV === "development"
//     ? "/proxy-server" //本地代理
//     : "https://mini.hyxmp.com"; //线上接口地址   http://124.223.76.2:6688

    /* 请求接口地址管理 */
/* 注：使用NODE_ENV环境变量名称导致本机环境变量覆盖env文件的变量，可使用 VUE_APP_ENV 代替 */
// console.log("VUE_APP_BASE_URL", process.env.NODE_ENV, process.env.VUE_APP_ENV,process.env.VUE_APP_BASE_URL)
export var IP = process.env.VUE_APP_BASE_URL
